import type { ComponentType } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { ChevronDown } from "lucide-react";
import type { NamedItem } from "@/components/excerpts/ExcerptsBulkBar";

export const FacetFilterPopover = ({
  label,
  Icon,
  items,
  selectedLower,
  selectedCount,
  onToggle,
  onClear,
  ariaLabel,
}: {
  label: string;
  Icon: ComponentType<{ className?: string }>;
  items: NamedItem[];
  selectedLower: string[];
  selectedCount: number;
  onToggle: (name: string) => void;
  onClear: () => void;
  ariaLabel: string;
}) => (
  <Popover>
    <PopoverTrigger asChild>
      <Button variant="outline" size="sm" className="h-9 gap-2" aria-label={ariaLabel}>
        <Icon className="h-3.5 w-3.5" />
        {label}
        {selectedCount > 0 ? (
          <span className="ml-1 inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-semibold text-primary-foreground">
            {selectedCount}
          </span>
        ) : null}
        <ChevronDown className="h-3.5 w-3.5 opacity-60" />
      </Button>
    </PopoverTrigger>
    <PopoverContent align="start" className="w-56 p-2">
      <div className="max-h-64 overflow-y-auto space-y-0.5">
        {items.map((item) => {
          const checked = selectedLower.includes(item.name.toLowerCase());
          return (
            <label
              key={item.id}
              className="flex cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 text-sm hover:bg-muted"
            >
              <Checkbox
                checked={checked}
                onCheckedChange={() => onToggle(item.name)}
                aria-label={item.name}
              />
              <span className="flex-1 truncate">{item.name}</span>
            </label>
          );
        })}
      </div>
      {selectedCount > 0 ? (
        <button
          type="button"
          onClick={onClear}
          className="mt-1 w-full rounded-md px-2 py-1.5 text-left text-xs text-muted-foreground hover:bg-muted"
        >
          Clear {label.toLowerCase()}
        </button>
      ) : null}
    </PopoverContent>
  </Popover>
);
